export const ControlLocalizationENUS = {
    Expand: 'Expand',
    Collapse: 'Collapse',
    Audio: 'Audio',
    AudioNotLoaded: 'Audio could not be loaded',
    BingMapsError: 'Unable to get data from Bing',
    YearSelector: 'Year Selector',
    DateSelector: 'Date Selector',
    Close: 'Close',
    Today: 'Today',
    PreviousMonth: 'Previous Month',
    NextMonth: 'Next Month',
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    ToDate: 'To Date',
    Advanced: 'Advanced',
    Basic: 'Basic',
    Search: 'Search',
    Selected: 'Selected',
    SearchedAllAvailableOptions: 'Searched All Available Options',
    Filters: 'Filters',
    FilterOptions: 'Filter Options',
    CustomDates: 'Custom Dates',
    DateRange: 'Date Range',
    From: 'From',
    To: 'To',
    SortBy: 'Sort By',
    Ascending: 'Ascending',
    Descending: 'Descending',
    HalfScreenView: 'Half Screen View',
    FullScreenView: 'Full Screen View',
    SummaryView: 'Summary View',
    DetailView: 'Detail View',
    Print: 'Print',
    DefaultView: 'Default View',
    CustomDatesErrorDaysFront: 'The Date Range must be less than ',
    CustomDatesErrorDaysEnd: ' days long.',
    CustomDatesErrorFromGreater: 'The From Date must be less than the To Date.',
    Save: 'Save',
    Cancel: 'Cancel',
    SortColumn: 'Sort Column',
    SortDirection: 'Sort Direction',
    SelectSorting: 'Select Sorting',
    Error: 'Error',
    OK: 'OK',
    Warning: 'Warning',
    More: 'More',
    MoreOptions: 'More Options',
    NoResults: 'No Results',
    Select: 'Select',
    SelectAll: 'Select All',
    DeselectAll: 'Deselect All',
    FilterList: 'Filter List',
    Available: 'Available',
    CheckAll: 'Check All',
    TextFieldErrorPhone: 'The phone number must be ten digits.',
    TextFieldErrorInvalidLength: 'Invalid phone number length',
    ClientSearchPhoneValidationMsg:
        'Phone input must be a 10 digit phone number, a 7 digit phone number, or the last 4 digits of a phone number.',
    MonthError: 'Please enter a number from 0 to 11.',
    InvalidZipCode: 'Invalid ZIP Code',
    ClearSSN: 'Clear SSN',
    Calendar: 'Calendar',
    SearchUsing: 'Search Using',
    QuickSearchNameEmailPhone: 'Name, Email, Phone',
    QuickSearchLicPlateNumber: 'License Plate Number',
    QuickSearchDesiredStkNumber: 'Desired Stock Number',
    QuickSearchDesiredVinNumber: 'Desired VIN',
    DMSIdList: 'DMS ID',
    QuickSearch: 'Quick Search',
    VINFilterValidationMessage: 'VIN input requires either the full 17 characters, or the last 6 or 8 characters of the VIN.',
    Delete: 'Delete',
    Add: 'Add',
    CurrentWeek: 'Current Week',
    CurrentMonth: 'Current Month',
    LastWeek: 'Last Week',
    Last2Weeks: 'Last 2 Weeks',
    Last60Days: 'Last 60 Days',
    LastMonth: 'Last Month',
    Last2Days: 'Last 2 Days',
    Last3Days: 'Last 3 Days',
    Last7Days: 'Last 7 Days',
    Last30Days: 'Last 30 Days',
    Last45Days: 'Last 45 Days',
    Custom: 'Custom',
    SelectedDay: 'Selected Day',
    SelectedDayPlusPreviousDay: 'Selected Day + Previous Day',
    SelectedDayPlusPrevious2Days: 'Selected Day + Previous 2 Days',
    SelectedDayPlusPrevious3Days: 'Selected Day + Previous 3 Days',
    SelectedDayPlusPrevious4Days: 'Selected Day + Previous 4 Days',
    SelectedDayPlusPrevious5Days: 'Selected Day + Previous 5 Days',
    SelectedDayPlusPrevious6Days: 'Selected Day + Previous 6 Days',
    SelectedDayPlusPrevious7Days: 'Selected Day + Previous 7 Days',
    SelectedDayPlusPrevious8Days: 'Selected Day + Previous 8 Days',
    SelectedDayPlusPrevious9Days: 'Selected Day + Previous 9 Days',
    SelectedDayPlusPrevious10Days: 'Selected Day + Previous 10 Days',
    SelectedDayPlusPrevious11Days: 'Selected Day + Previous 11 Days',
    SelectedDayPlusPrevious12Days: 'Selected Day + Previous 12 Days',
    SelectedDayPlusPrevious13Days: 'Selected Day + Previous 13 Days',
    SelectedDayPlus1Day: 'Selected Day + 1 Day',
    SelectedDayPlus2Days: 'Selected Day + 2 Days',
    Yesterday: 'Yesterday',
    Other: 'Other',
};
